import { render } from "./OtherWatchCard.vue?vue&type=template&id=506ff064"
import script from "./OtherWatchCard.vue?vue&type=script&lang=js"
export * from "./OtherWatchCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__